module.exports = __webpack_public_path__ + "static/media/yt.f7a8463e.png";